import React from 'react';
import Navbar from './components/Navbar';
import { Outlet } from 'react-router-dom';
import ScrollToTop from 'react-scroll-to-top';
import ScrollManager from './components/ScrollManager';
import { ReactComponent as Up } from './assets/up.svg';

const Layout = () => {
  return (
    <>
      <ScrollManager />
      <ScrollToTop
        smooth
        className="bm-scroll-top"
        component={<Up />}
        style={{
          width: '44px',
          height: '44px',
          padding: '10px',
          borderRadius: '50%',
          backgroundColor: '#17407A',
          color: '#fff',
        }}
      />
      <Navbar />
      <main className="site-main">
        <Outlet />
      </main>
    </>
  );
};

export default Layout;
